import { z } from "zod";
import { EPaySchedule } from "../../employees";
import { schemes } from "../../schema-validation";

export const reportingPeriodsSchema = z.object({
  _id: schemes.mongoObjectId(),
  start_date: schemes.isoDate(),
  pay_schedule: z.nativeEnum(EPaySchedule),
  end_date: schemes.isoDate(),
});

export type ReportingPeriod = z.infer<typeof reportingPeriodsSchema>;

export const reportingPeriodMapSchema = z.record(
  reportingPeriodsSchema.omit({ _id: true, pay_schedule: true })
);
export type ReportingPeriodMap = z.infer<typeof reportingPeriodMapSchema>;
